import { applyMiddleware, combineReducers, createStore } from "redux";
import { routerMiddleware, routerReducer } from "react-router-redux";

import { composeWithDevTools } from "redux-devtools-extension";
import thunkMiddleware from "redux-thunk";
import handleAsyncHttpError from "./asyncHttpError";
import activityTrackerMiddleware from "./tracker";
import { uuidv4 } from "../helpers/random";

import reducers from "./../modules";

const createHistory = require("history").createBrowserHistory;
const history = createHistory();

history.listen(location => {
    window.analytics &&
        window.analytics.page(location.pathname + location.search);

    if (!!window.Appcues) {
        window.Appcues.page();

        // this may not exist until a user has logged in, so we may end up
        // with both an ANON_WEVO_ID and AUTHED_WEVO_USER in storage.
        // this is ok.
        let wevoUser;
        try {
            let lsPayload = JSON.parse(
                localStorage.getItem("AUTHED_WEVO_USER")
            );
            wevoUser = Object.values(lsPayload.entities.users)[0];
        } catch (err) {
            console.log("unable to parse AUTHED user from ls");
        }

        if (!!wevoUser) {
            window.Appcues.identify(wevoUser.id, {
                name: `${wevoUser.name} ${wevoUser.lastName}`,
                email: wevoUser.email
            });
        } else {
            let anonId = localStorage.getItem("ANON_WEVO_ID");
            if (!anonId) {
                anonId = `anon-${uuidv4()}`;
                localStorage.setItem("ANON_WEVO_ID", anonId);
            }
            window.Appcues.identify(anonId);
        }
    }
});

// create devtools extension enhancer wrapper
const composeEnhancers = composeWithDevTools({});
const reduxRouterMiddleware = routerMiddleware(history);

const configureStore = initialState => {
    const store = createStore(
        combineReducers({
            ...reducers,
            router: routerReducer
        }),
        initialState,
        composeEnhancers(
            applyMiddleware(
                thunkMiddleware,
                reduxRouterMiddleware,
                handleAsyncHttpError,
                activityTrackerMiddleware
            )
            //autoRehydrate()
        )
    );

    // starts persisting the store periodically to local storage
    //persistStore(store, { storage: localForage })
    return store;
};

export { history };
export default configureStore;



// WEBPACK FOOTER //
// ./src/store/index.js